import { NextPage } from 'next/types'
import { Card } from 'react-bootstrap'
import { useAccount } from 'web_core/context/account'
import { useElementSize, useMedia } from 'web_core/hooks'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import {
  FAQSection,
  FeaturesSection,
  FirstViewSection,
  OverviewSection,
  PlanComparisonSection,
  PlanSection,
  TargetUsersSection,
} from '~/components/Page/Pricing'
import { ActionButton } from '~/components/Page/Pricing/ActionButton'
import styles from '~/styles/_pricing.module.scss'

export const getStaticProps = makeLocaleStaticProps

const Footer = () => {
  return (
    <section className={`${styles.footer} bg-primary d-none d-lg-block`}>
      <p className="text-center">もっとMathlogが楽しくなる!</p>
      <div className="d-flex justify-content-center">
        <ActionButton
          location="footer"
          variant="light"
          className={`${styles['pricing-btn']} text-primary w-100`}
          style={{ maxWidth: 350 }}
        />
      </div>
    </section>
  )
}

const FloatingButton = () => {
  const isLg = useMedia('lg', false)
  const { height: cardHeight, elementRef: cardRef } = useElementSize()
  return (
    <>
      <Card
        ref={cardRef}
        className={`position-fixed bottom-0 border-0 ${
          styles['pricing-shadow']
        } ${isLg ? 'end-0 mb-5 me-5' : 'rounded-0 w-100'}`}
      >
        <Card.Body>
          <p className="text-center mb-2 d-none d-lg-block">
            Mathlogプレミアムプラン
          </p>
          <ActionButton
            location="sticky"
            variant="primary"
            className={`${styles['pricing-btn']} py-2 fs-6 w-100`}
          />
        </Card.Body>
      </Card>
      <div className="d-lg-none" style={{ height: cardHeight }} />
    </>
  )
}

const Page: NextPage = () => {
  const { account } = useAccount()

  // ActionButtonの表示/非表示と同じロジック
  const showCVArea =
    account === null
      ? true
      : !(account === undefined || account.plan !== 'Free')

  return (
    <DefaultLayout
      head={{
        title: 'プレミアムプラン',
        description:
          '数学好きのみなさま向けに、共同編集や限定公開、LaTeXエクスポートなど、今までよりも情報共有や学びの記録を自由にできる機能をご用意しました。今後も、数学に没頭できる機能を次々と追加していきます。お楽しみに！',
      }}
      padding={{ pc: false, sp: false }}
    >
      <div className={styles.pricing}>
        <FirstViewSection />
        <OverviewSection />
        <TargetUsersSection />
        <PlanSection maxWidth={980} />
        <FeaturesSection />
        <PlanComparisonSection />
        <FAQSection />
        {showCVArea && (
          <>
            <Footer />
            <FloatingButton />
          </>
        )}
      </div>
    </DefaultLayout>
  )
}

export default Page
